module.exports = __webpack_public_path__ + "static/salon-pasajeros---asientos-de-plastico-a0b0a2c4d9652029d48908fb3948d013.jpg";